import HttpMethods from "../../../Services/httpMethods";
import { makeRequest } from "../../../Services/restcall";
import { ApiResponse } from "../../../Services/types";


export async function deleteImagenAPI(urlImagen:string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.DELETE, '/api/commerce/delete-img?urlImagen='+urlImagen,value)
}